const cleanupHandlers = new Set<() => void>()
export function onChatAuthorityCleared(handler: () => void): () => void {
  cleanupHandlers.add(handler)

  return () => cleanupHandlers.delete(handler)
}
export function clearChatAuthority(): void {
  for (const handler of cleanupHandlers) handler()
}
